<template>
  <FormRow :label="label" :labelColumnSize="6">
    <template v-slot:label>
      <InlineHelpPopover :title="helpTitle || label" placement="right">
        <slot name="helpContent" />
        <strong>Default:</strong> {{helpDefault}}
      </InlineHelpPopover>
    </template>
    <FormStaticLabel>
      <slot name="entry" />
    </FormStaticLabel>
  </FormRow>
</template>


<script>
export default {
  name: 'FormAccountSetting',
  props: {
    label: String,
    helpTitle: String,
    helpDefault: {
      type: String,
      default: 'None'
    }
  }
}
</script>